"use client";
import { useState } from "react";
import ProductCard from "@/components/ProductCard"
import SwiperComponent from "./ui/swiper-component";

const HomeProductsSliderSkeleton = () => (
    <div className="py-2 lg:py-4 w-full relative">
        <div className="flex gap-2 lg:gap-4 overflow-hidden">
            {[...Array(6)].map((_, i) => (
                <div
                    key={i}
                    className="flex-none w-[calc(100%/1.7)] md:w-[calc(100%/3.5-12px)] lg:w-[calc(100%/4.5-12px)] xl:w-[calc(100%/5.5-12px)]"
                >
                    <div className="h-[300px] lg:h-[350px] bg-jmt-neutral-100 rounded-md w-full"></div>
                </div>
            ))}
        </div>
    </div>
);


const RelatedProducts = ({ className = "mb-8", related_products, title, limit = 10, }) => {
    const [loading, setLoading] = useState(true);

    if (loading && !related_products) return <HomeProductsSliderSkeleton />;

    return (
        <div className={className}>
            {related_products.length > 0 ? (
                <>
                    <h3 className="text-base lg:text-xl text-jmt-main font-bold mb-2 lg:mb-4"> {title} </h3>

                    {/* product card */}
                    <SwiperComponent
                            slides_shadow_space
                        slides={related_products.slice(0, limit).map((product, index) => (
                            <div
                                key={`product--key${product.id}`}
                                className="h-full bg-white border border-jmt-neutral-200 hover-shadow-full-light rounded-md overflow-hidden">
                                <ProductCard
                                    product={product} index={index}
                                />
                            </div>
                        ))}
                        breakpoints={{
                            380: { slidesPerView: 2.1, spaceBetween: 8 },
                            500: { slidesPerView: 2.8, spaceBetween: 8 },
                            640: { slidesPerView: 3, spaceBetween: 8 },
                            767: { slidesPerView: 3.5, spaceBetween: 12 },
                            920: { slidesPerView: 4, spaceBetween: 12 },
                            1024: { slidesPerView: 4.5, spaceBetween: 16 },
                            1280: { slidesPerView: 5.5, spaceBetween: 16 },
                        }}
                        slidesPerView={1.5}
                        spaceBetween={8}
                        navigation={true}
                        hideNavOnMobile={true}
                        navPosition="sides"
                        loop={false}
                        pagination={false}
                        grabCursor={true}
                    />
                </>
            ) : ""}


        </div>
    );
};

export default RelatedProducts;


